import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';

const MOD = navigator.platform.toUpperCase().includes('MAC') ? '⌘' : 'Strg';

/** The editor's keyboard shortcuts, in one place. */
@Component({
  selector: 'app-shortcuts-dialog',
  standalone: true,
  imports: [HlmButtonImports, HlmDialogImports],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onState($event)">
      <hlm-dialog-content *hlmDialogPortal class="max-w-md">
        <div hlmDialogHeader>
          <h3 hlmDialogTitle>Tastenkürzel</h3>
          <p hlmDialogDescription>Was die Maus kann, geht auch mit der Tastatur.</p>
        </div>
        <dl class="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
          @for (row of rows; track row[1]) {
            <dt class="text-right">
              <kbd class="rounded border px-1.5 py-0.5 text-xs">{{ row[0] }}</kbd>
            </dt>
            <dd>{{ row[1] }}</dd>
          }
        </dl>
        <div hlmDialogFooter>
          <button hlmBtn type="button" (click)="close.emit()">Schließen</button>
        </div>
      </hlm-dialog-content>
    </hlm-dialog>
  `,
})
export class ShortcutsDialogComponent {
  readonly open = input(false);
  readonly close = output<void>();

  readonly rows: [string, string][] = [
    [`${MOD} S`, 'Layout speichern'],
    [`${MOD} Z`, 'Rückgängig'],
    [`⇧ ${MOD} Z`, 'Wiederholen'],
    [`${MOD} A`, 'Alle Elemente auswählen'],
    ['⇧ Klick', 'Element zur Auswahl hinzufügen oder entfernen'],
    ['Ziehen auf leerer Seite', 'Mehrere Elemente mit einem Rahmen auswählen'],
    [`${MOD} C`, 'Auswahl kopieren (auch in ein anderes Design)'],
    [`${MOD} X`, 'Auswahl ausschneiden'],
    [`${MOD} V`, 'Kopierte Elemente einfügen'],
    [`${MOD} D`, 'Auswahl duplizieren'],
    [`${MOD} G`, 'Auswahl gruppieren'],
    [`⇧ ${MOD} G`, 'Gruppierung aufheben'],
    ['Pfeiltasten', 'Auswahl um 1 pt bewegen, mit ⇧ um 10 pt'],
    [`⇧ ${MOD} .`, 'Schrift der Auswahl um 1 pt vergrößern'],
    [`⇧ ${MOD} ,`, 'Schrift der Auswahl um 1 pt verkleinern'],
    ['Entf', 'Auswahl entfernen'],
    ['⇧ beim Ziehen', 'Nicht einrasten (beim Vergrößern: Seitenverhältnis halten)'],
    [`${MOD} Ziehen auf einem Bild`, 'Bildausschnitt verschieben (bei „Füllen“)'],
    [`${MOD} Mausrad`, 'Zoomen'],
    ['Esc', 'Auswahl aufheben'],
    ['?', 'Diese Übersicht'],
  ];

  onState(state: 'open' | 'closed') {
    if (state === 'closed' && this.open()) this.close.emit();
  }
}
